import React, {Component} from 'react';
import {Table, Button} from 'react-bootstrap';
import swal from 'sweetalert';
import {translate}	from 'react-i18next';
import moment from 'moment';
import SvgIcon from 'react-icons-kit';
import {search} from 'react-icons-kit/icomoon/search';
import {bin} from 'react-icons-kit/icomoon/bin';
import Help from '../../generics/help';
import ModalDetails from './modalDetails';

const Config = require('../../../config');

class SuppliesOutput extends Component{
	constructor(props){
		super(props);

		this.getList = this.getList.bind(this);
		this.newEntry = this.newEntry.bind(this);
		this.onDelete = this.onDelete.bind(this);
        this.handleChange = this.handleChange.bind(this);

		this.state = {
			list:[],
			start_date:"",
			end_date:"",
			filter:""
		}
	}

	componentDidMount(){
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
			});

			this.getList();
		});
	}

	getList(){
		this.props.waiting.handleShow('Cargando...');

		fetch(Config.default.apiGateway.URL+'supplies_exit?start_date='+this.state.start_date+'&end_date='+this.state.end_date, {
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					list: response
				});
			}
		});
	}

	newEntry(){
		this.props.history.push('/supplies_reagents/output/new');
	}

	viewInformation(item){
		this.modal_details.handleShow(item);
	}

	onDelete(id){
		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar este registro?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, (isConfirm) => {
	        if (isConfirm) {
	          	this.props.waiting.handleShow('Eliminando...');
				fetch(Config.default.apiGateway.URL+'supplies_exit?id='+id+'&health_facilities_id='+
					sessionStorage.getItem('health_facilities_id'),{
					method: 'delete',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');	
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.getList();
						swal('Correcto', 'El registro se elimino correctamente.', 'success');
					}
				})
	        }
	    });
	}

    handleChange(e){
		var campo = e.target.name;
		this.setState({
			[campo]: e.target.value
		});
	}

	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Insumos ->
						Salidas  
					</h5>
				</div>


				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-2" style={{marginTop:'20px'}}>
						<input type="text" className="form-control" name="filter" id="filter" placeholder={"Filtro..."}
							value={this.state.filter} onChange={this.handleChange} />
						
					</div>
					<div class="col-xs-12 col-sm-2">
						<span className="span-min">Fecha inicial</span>
						<input type="date" name="start_date" id="start_date" value={this.state.start_date}
							className="form-control hour-input" onChange={this.handleChange} />
					</div>
					<div class="col-xs-12 col-sm-2">
						<span className="span-min">Fecha final</span>
						<input type="date" name="end_date" id="end_date" value={this.state.end_date}
							className="form-control hour-input" onChange={this.handleChange} />
					</div>
					<div className="col-xs-12 col-sm-2 col-sm-offset-4" style={{marginTop:'11px'}}>
						<button type="button" className="btn btn-info" style={{fontSize:"14px", marginRight:'5px'}}
							onClick={this.getList}>Buscar</button>
						<button type="button" className="btn btn-info" style={{fontSize:"14px"}}
							disabled={!this.props.supplies_output.create}
							onClick={this.newEntry}>Nuevo</button>
					</div>
				</div>

				<div className="col-xs-12">
					<Table responsive hover>
						<thead>
							<tr>
								<th>Fecha</th>
								<th>Unidad Médica</th>
								<th>Especialidad</th>
								<th>Usuario Envía</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{this.state.list.map((l, i)=>(
								<tr key={i}>
									<td>{moment(l.date).format('DD/MM/YYYY')}</td>
									<td>{l.center_name}</td>
									<td>{l.health_service}</td>
									<td>{l.person_send}</td>
									<td>
										<Button className="btn btn-info btn-xs" title="Detalles" style={{marginRight:"5px"}} 
											onClick={this.viewInformation.bind(this, l)} >
											<SvgIcon icon={search}/>
										</Button>
										<Button className="btn btn-info btn-xs" title="Retirar" style={{marginRight:"5px"}}
											onClick={(e)=>this.onDelete(l.id)}
											disabled={!this.props.supplies_output.delete} >
											<SvgIcon icon={bin} />
										</Button>
									</td>
								</tr>
							))}
						</tbody>
					</Table>
				</div>

				<ModalDetails {...this.props} onRef={ref => this.modal_details = ref} />
			</div>
		)
	}
}

export default translate('translations')(SuppliesOutput);